export enum WellTypes {
    horizontal = 'Horizontal',
    vertical = 'Vertical'
  }

  export enum StringTypes {
    coilTubing = 'Coiled Tubing',
    jointTubing = 'Jointed Tubing'
  }
